<!--BkResource: 备课 2022/10/25 10:51:14 Sunangaung-->

<template>
  <iframe id="iframe_bk" frameborder="0" :src="url" width="100%" height="100%" title="bk">
  </iframe>
</template>
  <script>
  export default {
    name: 'BkResource',
    data() {
      let bkUrl = process.env.VUE_APP_URL_BEIKE + '/index.html#/?mode=ekt&appId=91a751b9100c40ee'
      const nav = this.$route.query.nav
      if (nav) {
        bkUrl += '&nav=' + nav
      }
      const redirectUrl = process.env.VUE_APP_URL_BEIKE + '/ibook/sso/redirect?url=' + encodeURIComponent(bkUrl)
      return {
        url: process.env.VUE_APP_URL_BEIKE + '/ibook/users/logout?logout_sso=false&url=' + encodeURIComponent(redirectUrl)
      }
    },
    mounted () {
      document.getElementById('iclass-footer').style.display = 'none'
      localStorage.setItem(this.$el.id, process.env.VUE_APP_URL_BEIKE)
    },
    beforeDestroy () {
      document.getElementById('iclass-footer').style.display = 'block'
    }
  }
  </script>
  
  <style scoped>
  #iframe_bk {
    min-height: calc(100vh - 75px);
  }
  </style>
